export const LIGHT_MODE = 'light';
export const DARK_MODE = 'dark';
export const DEFAULT_MODE = DARK_MODE;

export const modes = [DARK_MODE, LIGHT_MODE];
